import React from 'react'
import { Input, IconButton } from '@shopflo/ui'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import { useEntitledProducts } from '../../../hooks/useEntitledProducts'
import { DiscountApplyToType, BxgyEntitlement } from 'src/lib/types/discountsV2'
import { AndBadge } from '../../../common/ProductIcons'
import { X } from '@phosphor-icons/react'
import CatalogueGroupControl from '../common/CatalogueGroupControl'
import { discountCatalogueErrors } from 'src/lib/utils/catalogueErrorHelpers'

const FreebieSelectorProductsList = () => {
  const {
    state: { entitlement: rawEntitlement, errors },
    actions: { setFormState }
  } = useDiscountForm()

  const entitlement = rawEntitlement as BxgyEntitlement
  const { entitledCatalogue, metaData, applyTo } = entitlement

  const catalogueType = applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS ? 'COLLECTION' : 'PRODUCT_AND_VARIANT'

  const {
    handleItemsSelected,
    handleRemoveGroup,
    handleRemoveIncludedItem,
    handleRemoveExcludedItem,
    handleQuantityChange,
    handleAddEmptyGroup,
    handleVariantUpdate
  } = useEntitledProducts({
    entitlement,
    setFormState,
    catalogueType
  })

  const renderList = () => {
    const metaItems = metaData?.entitledCatalogue || []
    const displayGroups = metaItems.length > 0 ? metaItems : [[]]

    return (
      <div className='flex flex-col'>
        {displayGroups.map((group, groupIndex) => {
          return (
            <div key={groupIndex} className='rounded-xl flex flex-col '>
              {displayGroups.length > 1 && (
                <div className='flex justify-between items-center'>
                  <div className='flex flex-col gap-3 py-3 items-center'>
                    <div className='flex items-center gap-2'>
                      {groupIndex > 0 && <AndBadge />}
                      {entitledCatalogue.length > 1 && (
                        <div className='flex items-center gap-2 '>
                          <Input
                            value={entitledCatalogue[groupIndex]?.quantity?.toString() ?? ''}
                            onChange={e => handleQuantityChange(groupIndex, e.target.value)}
                            onFocus={e => e.target.select()}
                            className='w-16 text-center'
                            type='number'
                            dimension='sm'
                            variant='filled'
                          />
                          <span className='text-text-sm-regular text-zinc-500 whitespace-nowrap'>free items from</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {groupIndex > 0 && (
                    <IconButton
                      onClick={() => handleRemoveGroup(groupIndex)}
                      variant='ghost'
                      size='xs'
                      IconComponent={X}
                      className='text-zinc-500'
                    />
                  )}
                </div>
              )}
              <div className='flex w-full'>
                <div className='border-l-1 border-zinc-200 w-5 rounded-l-lg border-y-1 h-auto'></div>
                <div className='flex flex-col rounded-lg px-2 w-full'>
                  <CatalogueGroupControl
                    groupIndex={groupIndex}
                    includedGroups={metaItems}
                    excludedGroups={metaData?.excludedCatalogue}
                    catalogueType={catalogueType}
                    actions={{
                      onRemoveIncludedItem: handleRemoveIncludedItem,
                      onRemoveExcludedItem: handleRemoveExcludedItem,
                      onUpdateItem: handleVariantUpdate,
                      onItemsSelected: handleItemsSelected,
                      onAddEmptyGroup: handleAddEmptyGroup
                    }}
                    errorHandling={{
                      errors: discountCatalogueErrors(errors, 'entitlement.entitledCatalogue')
                    }}
                    config={{
                      showVariantEditor: true,
                      addText: 'Add product',
                      showExclusionOption: true,
                      emptyText: catalogueType === 'COLLECTION' ? 'Choose Collections' : 'Choose Products'
                    }}
                  />
                </div>
                <div className='border-r-1 border-zinc-200 w-5 rounded-r-lg border-y-1  h-auto'></div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return <div className='flex w-full flex-col'>{renderList()}</div>
}

export default FreebieSelectorProductsList
